import { gql, useQuery } from '@apollo/client';
import {
  CSGetDocumentAnalysisByEntityStatus,
  DocumentAnalysis,
  DocumentAnalysisStatus,
  ModelSortDirection,
} from '@admiin-com/ds-graphql';
import { ForwardBills } from './ForwardBills';
import { useEntityId } from '../../../features/hooks/useEntityContext/useEntityContext';

interface Props {
  onClose: () => void;
  open: boolean;
  onAdd: (documentAnalysis: DocumentAnalysis[]) => void;
  source: 'EMAIL' | 'XERO';
}

export const ForwardBillsContainer = (props: Props) => {
  const entityId = useEntityId();
  const { data, refetch } = useQuery(gql(CSGetDocumentAnalysisByEntityStatus), {
    variables: {
      entityId,
      status: DocumentAnalysisStatus.SCANNED,
      limit: 100,
      sortDirection: ModelSortDirection.DESC,
      sortBy: 'createdAt',
    },
    skip: !props.open || !entityId,
  });

  let documentAnalysis = [
    ...(data?.documentAnalysisByEntityStatus?.items ?? []),
  ];

  documentAnalysis = documentAnalysis.filter(
    (item: DocumentAnalysis) => item.source === props.source
  );

  return (
    <ForwardBills
      onRefresh={async () => {
        await refetch({
          fetchPolicy: 'no-cache',
        });
      }}
      open={props.open}
      onClose={props.onClose}
      documentAnalysis={documentAnalysis}
      onAdd={props.onAdd}
    />
  );
};
